"use client"

import SelectPeople, { SelectPeopleRef } from "./SelectPeople"

export const refSelectPeople: { current: SelectPeopleRef | null } = { current: null }

const SelectPeopleWrapper = (props: any) => {
  return (
    <SelectPeople
      ref={(curr) => { refSelectPeople.current = curr; }}
      {...props}
    />
  )
}

export default SelectPeopleWrapper